import { all } from 'redux-saga/effects';
import userSagaWatcher from './user/saga';
import companySagaWatcher from './company/saga';
import investorSagaWatcher from './investor/saga';
import dashboardSaga from './dashboard/saga';
import dashboardOverviewSaga from './dashboard/overview/saga';
import creditBureauSaga from './dashboard/creditBureau/saga';
import auditedFinancialsSaga from './dashboard/auditedFinancials/saga';
import authSagaV2 from './user/userV2/authSaga';
import debtProductsSagaWatcher from './debtProducts/saga';
import bankingSagaWatcher from './banking/bankingSaga';
import reconciliationsSagaWatcher from './reconciliations/reconciliationsSaga';

export default function* rootSaga() {
    yield all([
        userSagaWatcher(),
        companySagaWatcher(),
        investorSagaWatcher(),
        dashboardSaga(),
        dashboardOverviewSaga(),
        creditBureauSaga(),
        auditedFinancialsSaga(),
        authSagaV2(),
        debtProductsSagaWatcher(),
        bankingSagaWatcher(),
        reconciliationsSagaWatcher(),
        // dashboardSagaWatcher(),
        // financialsSagaWatcher(),
        // benchmarkingSagaWatcher(),
        // classificationsSagaWatcher(),
        // dataVaultSagaWatcher(),
        // forecastsSagsWatcher(),
    ]);
}
